<template>
  <div class="historic-item" @click="click">
    <span
      :class="{
        icon: true,
        'payment-declined': data.value.toLowerCase().indexOf('recusado') > -1,
      }"
    >
      <img
        :src="data.icon['@1x']"
        :srcset="`${data.icon['@1x']} 1x, ${data.icon['@2x']} 2x, ${data.icon['@3x']} 3x`"
      />
    </span>
    <div>
      <span class="summary-label">
        <span class="summary-label-text">{{ data.title }}</span>
        <div class="summary-detail-area">
          <span class="summary-icon">
            <img
              :src="((data.summary || {}).image || [])['@1x']"
              :srcset="`${((data.summary || {}).image || [])['@1x']} 1x,
              ${((data.summary || {}).image || [])['@2x']} 2x,
              ${((data.summary || {}).image || [])['@3x']} 3x`"
            />
          </span>
          <span class="summary-detail">{{
            (data.summary || {}).detail || ""
          }}</span>
        </div>
      </span>
      <span
        :class="{
          sub: true,
          'payment-declined': data.value.toLowerCase().indexOf('recusado') > -1,
        }"
        >{{ data.value }}</span
      >
      <span class="sub date">{{ data.date | moment("DD MMM[.] YYYY") }}</span>
      <span class="icon is-ext"></span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: Object,
  },
  data() {
    return {};
  },
  methods: {
    click() {
      this.$emit("click");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/sass/variables";

.historic-item {
  display: flex;
  position: relative;

  color: $black;
  background: $white;
  // justify-content: space-between;
  padding: 20px;
  border-top: 1px $white-ter solid;
  cursor: pointer;
  transition: 0.2s all;

  &:hover {
    background-color: $white-bis;
  }

  & > div {
    position: relative;
    flex-direction: column;
    align-items: flex-start;
    margin-left: 20px;
    width: calc(100% - 92px);

    @media screen and (min-width: 769px) {
      display: flex;
      flex-direction: row !important;
      align-items: center;
      width: calc(100% - 35px);
    }
  }
}

.icon {
  margin: auto 0.25rem;
  opacity: 1;

  &:not(.is-ext) {
    width: 35px;
    height: 35px;
    border-radius: 50%;
    display: inline-flex;
    align-items: center;
    justify-content: center;

    &:before,
    &:after {
      content: "";
      display: block;
      width: 1px;
      background-color: whitesmoke;
      height: calc((100% - 35px) / 2);
      position: absolute;
    }

    &:before {
      top: 0;
    }

    &:after {
      bottom: 0;
    }

    @each $city, $map in $cities {
      .is-#{$city} & {
        background-color: map-get($map, "primary");
      }
    }

    &.payment-declined {
      > img {
        display: block;
        margin-top: 2px;
      }
      @each $city, $map in $cities {
        .is-#{$city} & {
          background-color: #ff3860;
        }
      }
    }
  }

  &.is-ext {
    mask-image: $extIcon;
    mask-repeat: no-repeat;
    mask-position: center center;
    margin: 0;

    position: absolute;
    bottom: -25px;
    right: -38px;

    @media screen and (min-width: 769px) {
      position: static;
    }

    @each $city, $map in $cities {
      .is-#{$city} & {
        background-color: map-get($map, "primary");
      }
    }
  }
}

.summary-label {
  margin-bottom: 0 !important;
  margin-right: auto;
  width: 185px;
  display: flex;
  flex-direction: column;

  .summary-label-text {
    font-size: 14px;
    font-weight: 700;
  }

  .summary-detail-area {
    display: flex;
    align-items: center;
  }

  .summary-icon > img {
    width: 22px;
  }

  .summary-icon,
  .summary-detail {
    display: inline-flex;
  }

  .summary-detail {
    font-size: 12px;
    margin-left: 6px;
    font-weight: 700;
    color: #666;
  }
}

.sub {
  font-size: 14px;
  margin-right: auto;

  &:not(.date) {
    font-weight: 700;

    @each $city, $map in $cities {
      .is-#{$city} & {
        color: map-get($map, "primary");
      }
    }
  }

  &.payment-declined {
    @each $city, $map in $cities {
      .is-#{$city} & {
        color: #ff3860;
      }
    }
  }

  &.date {
    text-transform: uppercase;
    position: absolute;
    top: -15px;
    right: -20px;
    font-size: 10px;

    @media screen and (min-width: 769px) {
      position: static;
      font-size: 12px;
    }
  }
}
</style>
